import router from "./router"
import store from "./store"
import { Message } from "element-ui"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import { getToken } from "@/utils/auth"
import { getConfigKey } from "@/api/system/config"

NProgress.configure({ showSpinner: false })

const whiteList = [
  "/login",
  "/auth-redirect",
  "/bind",
  "/",
  "/register",
  "/default",
  "/register_new",
  "/login_new",
  "/reset",
  "/login_admin",
  "/product",
  "/goods",
  "/advantage",
  "/vip",
  "/product_type",
  "/contact",
  "/index1",
  "/app_register",
  "/app_login",
  "/ad",
  "/site_router",
  "/erp"
  // "/rank"
]

router.beforeEach((to, from, next) => {
  NProgress.start()
  let _self = this
  if(to.meta && to.meta.title){
    window.document.title = to.meta.title + ' | 1号定制'
  }
  if (getToken()) {
    /* has token*/
    if (to.path === "/login") {
      next({ path: "/" })
      NProgress.done()
    } else {
      next()
      if (store.getters.roles.length === 0) {
        //   // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch("GetInfo")
          .then(async(res) => {
            // 拉取user_info
            const roles = res.roles
            // 设计器都是新开页面，所以store.getters.roles.length === 0中判断即可
            let designSwitch = await getConfigKey("design_switch")
            if (designSwitch.code == 200) {
              sessionStorage.setItem("design_switch", designSwitch.msg || "0")
              if (!localStorage.getItem("isNewDesignFlag")) {  //第一次打开时默认根据路径打开，新版1，旧版为2
                if (to.path === '/design/online/designerOther') {
                  localStorage.setItem("isNewDesignFlag", "2")
                } else {
                  localStorage.setItem("isNewDesignFlag", "1")
                }
              }
              const isNewDesignTemp = localStorage.getItem("isNewDesignFlag")
              if (to.path === '/design/online/tool') { //设计器入口根据后台配置置判断是否强制跳转
                const designSwitch = sessionStorage.getItem('design_switch')
                if (designSwitch === '1') {
                  if (isNewDesignTemp === '2') {
                    store.dispatch("GenerateRoutes", { roles }).then((accessRoutes) => {
                      router.addRoutes(accessRoutes)
                      next({ path: '/design/online/designerOther', query: to.query, replace: true })
                    })
                    return
                  } else {
                    store.dispatch("GenerateRoutes", { roles }).then((accessRoutes) => {
                      router.addRoutes(accessRoutes)
                      next({ path: '/design/online/designerNew', query: to.query, replace: true })
                    })
                    return
                  }
                }
              } else if (to.path === '/design/online/designerOther' || to.path === '/design/online/designerNew') { //新设计器根据默认设置判断是否强制跳转
                if (isNewDesignTemp === '2') {
                  store.dispatch("GenerateRoutes", { roles }).then((accessRoutes) => {
                    router.addRoutes(accessRoutes)
                    next({ path: '/design/online/designerOther', query: to.query, replace: true })
                  })
                  return
                } else {
                  store.dispatch("GenerateRoutes", { roles }).then((accessRoutes) => {
                    router.addRoutes(accessRoutes)
                    next({ path: '/design/online/designerNew', query: to.query, replace: true })
                  })
                  return
                }
              }
            }
            store.dispatch("GenerateRoutes", { roles }).then((accessRoutes) => {
              // 测试 默认静态页面
              // store.dispatch('permission/generateRoutes', { roles }).then(accessRoutes => {
              // 根据roles权限生成可访问的路由表
              router.addRoutes(accessRoutes) // 动态添加可访问路由表
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
            })
          })
          .catch((err) => {
            store.dispatch("FedLogOut").then(() => {
              Message.error(err)
              next({ path: "/" })
            })
          })
      } else {
        if (!to.name) {
          let path = to.path.split("?")[0]
          let routers = JSON.stringify(store.state.permission.addRoutes)

          if (routers && routers.indexOf(path) == -1) {
            Message.error("该账户没有权限")
            next({ path: from.path })
            return
          }
        }
        next()

        //   // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        //   // if (hasPermission(store.getters.roles, to.meta.roles)) {
        //   //   next()
        //   // } else {
        //   //   next({ path: '/401', replace: true, query: { noGoBack: true }})
        //   // }
        //   // 可删 ↑
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next("/login") // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
